// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__33wf1","title":"ClientReferral_title__17v4o","itemText":"ClientReferral_itemText__1AgZL"};